import { default as throttle } from 'lodash.throttle';
import { useLayoutEffect, useState } from 'react';

import { browserConfig } from '../../configs/BrowserConfig';

const WINDOW_SCREEN_ORIENTATION = {
  LANDSCAPE_PRIMARY: 'landscape-primary',
  LANDSCAPE_SECONDARY: 'landscape-secondary',
  PORTRAIT_SECONDARY: 'portrait-secondary',
  PORTRAIT_PRIMARY: 'portrait-primary',
} as const;

/**
 * Window resize listener for getting true/false if screen orientation is portrait.
 * Works only for mobile devices, for desktop always returns false.
 */
export function useIsPortraitScreenOrientation(): boolean {
  const [isPortrait, setIsPortrait] = useState<boolean>(false);

  useLayoutEffect(() => {
    if (browserConfig.BROWSER?.isMobile && 'visualViewport' in window) {
      const onResize = () => {
        switch (window.screen.orientation?.type) {
          case WINDOW_SCREEN_ORIENTATION.PORTRAIT_PRIMARY:
          case WINDOW_SCREEN_ORIENTATION.PORTRAIT_SECONDARY:
            setIsPortrait(true);
            break;
          case WINDOW_SCREEN_ORIENTATION.LANDSCAPE_PRIMARY:
          case WINDOW_SCREEN_ORIENTATION.LANDSCAPE_SECONDARY:
            setIsPortrait(false);
            break;
          default:
            // Fallback if the orientation API isn't supported in current browser
            const { height, width } = document.body.getBoundingClientRect();
            const aspectRatio = height / width;
            setIsPortrait(aspectRatio >= 1);
        }
      };

      const throttledOnResize = throttle(onResize, 100);

      onResize();

      window.visualViewport.addEventListener('resize', throttledOnResize);

      return () => {
        window.visualViewport.removeEventListener('resize', throttledOnResize);
      };
    }
  });

  return isPortrait;
}
